import React, {useContext} from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import logo from '../../images/unnamed.jpg'
import TokenContext from "../../context/Token/TokenContext";
import ReclamoContext from '../../context/reclamo/reclamoContext';

const Appbar = ({history}) => {
  const tokenContext = useContext(TokenContext);
  const { Active_Token_F, redirect_login, Redirect_F } = tokenContext;
  const reclamoContext = useContext(ReclamoContext);
  const { Get_Temporales_F } = reclamoContext;

  const CerrarSesion = () => {
    localStorage.clear();
    Active_Token_F('')
    Get_Temporales_F([])
    window.location.href = "https://accounts.claveunica.gob.cl/api/v1/accounts/app/logout"
    history.push('/');
  }

    return (
        <Navbar bg="white" fixed="top" className= "shadow-sm  ">
          <Navbar.Brand href="#">
            <img
              alt="Logo Super Intendencia"
              src={logo}
              className="w-75"
            />
          </Navbar.Brand>
            <Nav className="ml-auto">
              <Nav.Link href="#" className="font-primary-ss" onClick={CerrarSesion}>Cerrar Sesión</Nav.Link>
            </Nav>
        </Navbar>
    )
}

export default Appbar